<template>

  <div>
    <ul
      class="list-group"
      v-if="fileList">
      <li
        class="list-group-item"
        v-for="(file, index) in fileList"
        :key="index">
        <a
          href="javascript:void(0)"
          class="remove"
          @click="removeFile(index)">
          <i class="fas fa-times" />
          </a>
        {{ file.title }}
        </li>
    </ul>
    <label
      class="btn btn-secondary" 
      :class="{'box-loading': loading, [btClass]: true}"
      v-if="fileList.length < limit"
      style="cursor:pointer;">
      <slot></slot>
      <input
        type="file"
        multiple="multiple"
        class="form-control"
        @change="uploadFile($event)"
        style="display: none;">
    </label>
    <div
      v-if="errorSizeLimit"
      class="alert alert-warning">
      O arquivo deve ter no máximo 3,4Mb.
    </div>
  </div>

</template>

<script>
// import FileReader from '@/utils/FileReader'

export default {
  name: 'InputMedia',
  components: {
  },
  props: {
    'value': {
      type: [Array, Object],
      default: null
    },
    'multiple': {
      type: Boolean,
      default: true
    },
    'btClass': {
      type: String,
      default: ''
    }
  },
  computed: {
    fileList () {
      if (!this.value) return []
      else return Array.isArray(this.value) ? this.value : [this.value]
    },
    limit () {
      return this.multiple ? 100 : 1
    }
  },
  data () {
    return {
      loading: false,
      errorSizeLimit: false
    }
  },
  methods: {
    uploadFile (event) {
      this.loading = true

      const files = Object.values(event.target.files)

      Promise.all(files.map((file) => {
        const formData = new FormData()
        formData.append('file', file)
        return this.$store.dispatch('createMediaMultipart', formData)

        // return FileReader(file)
        // .then((base64) => {
        //   return {
        //     'title': file.name,
        //     'base64': base64
        //   }
        // })
        // .then((data) => {
        //   return this.$store
        //   .dispatch('createMedia', data)
        // })
      }))
      .then((result) => {
        this.loading = false
        this.$emit('input', this.multiple ? result : result[0])
      }).catch(err => {
        if (err.response.status === 413) {
          this.errorSizeLimit = true
          this.loading = false
        }
      })
    },
    removeFile (index) {
      const filtered = this.fileList.filter((val, key) => {
        return key !== index
      })
      this.$emit('input', this.multiple ? filtered : filtered[0])
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-group{
}
  .list-group .remove{
    float: right;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputMedia.vue